import { Smartphone } from 'lucide-react';
import { formatConnectionPhone } from '@/lib/whatsappErrorMessages';

/** Mesma orientação no CRM e no link público de pareamento. */
export default function WhatsAppQrInstructions({ telefone }: { telefone?: string | null }) {
  return (
    <div className="space-y-3 text-left text-sm">
      <div className="rounded-lg border bg-muted/30 p-3">
        <p className="text-xs text-muted-foreground">WhatsApp que deve ler este QR</p>
        <p className="font-semibold text-lg">{formatConnectionPhone(telefone) || 'O número que você deseja cadastrar'}</p>
        <p className="text-xs text-muted-foreground">Confira o número nas configurações do WhatsApp antes de continuar.</p>
      </div>
      <p className="font-medium flex items-center gap-2"><Smartphone className="h-4 w-4" /> Abra esta tela no computador</p>
      <p className="text-xs text-muted-foreground">Se abriu o link no celular da linha, abra esse mesmo link no computador ou em outro aparelho para conseguir escanear.</p>
      <ol className="list-decimal pl-5 space-y-2 text-sm">
        <li>No celular da linha, abra o <strong>WhatsApp</strong> ou <strong>WhatsApp Business</strong> que usa esse número.</li>
        <li>No Android, toque nos <strong>três pontos</strong>. No iPhone, abra <strong>Configurações</strong>.</li>
        <li>Entre em <strong>Aparelhos conectados → Conectar um aparelho</strong> e aponte a câmera para o QR nesta tela.</li>
        <li>Aguarde a confirmação de conexão aqui no CRM.</li>
      </ol>
      <p className="text-xs text-muted-foreground">O QR é atualizado automaticamente. Use o QR desta página aberta; uma foto antiga pode ter expirado.</p>
    </div>
  );
}
